// extracted by mini-css-extract-plugin
export default {"control":"styles_control__E0U-Q","control__pushBackButton":"styles_control__push-back-button__HDQ08","control__statuses":"styles_control__statuses__rF3A1"};